let resizeTimer = false

const calculateViewportUnits = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}

const calculateHeaderSize = () => {
    const header = document.querySelector('.l-header')

    if (!header) {
        return
    }

    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`)
}

calculateViewportUnits()
calculateHeaderSize()

window.addEventListener('resize', event => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
        calculateViewportUnits()
        calculateHeaderSize()

        window.rEvent.dispatch('Window.resized');
    }, 250);
});

export { calculateHeaderSize, calculateViewportUnits }